module.exports = __webpack_public_path__ + "img/DigitalSinglePage1.8231e083.jpg";